<app-hourglass *ngIf="!ready || hourglass"></app-hourglass>
<div class="row-flex-4">
    <span mat-dialog-title>{{ currentGroup.name }} - Change Schedule</span>
    <app-timezone (selectedEvent)="handleTimezoneChange($event)" [defaultId]="defaultID"
                  [disabled]="updatedScheduleList === undefined || updatedScheduleList.length > 0"
                  class="app-timezone" id="appTimezone"></app-timezone>
    <span>
        <button (click)="schedulePopup()" id="addNewEntry" class="add-entry-button" color="primary" mat-raised-button>
            Add New Entry
            <mat-icon>add_circle</mat-icon>
        </button>
    </span>
</div>
<mat-dialog-content *ngIf="ready && scheduleList">
    <mat-card *ngFor="let entry of updatedScheduleList; let i = index">
        <div class="row-flex">
            <div class="row-flex-2">
                <div class="entry-labels">
                    <label class="mt10">Entry Name: </label>
                </div>
                <mat-form-field class="w50">
                    <input [(ngModel)]="entry.entry_name" (ngModelChange)="clearNextRotation()" required
                           class="w50" id="updateEntryName{{i}}" matInput>
                </mat-form-field>
            </div>
            <div *ngIf="updatedScheduleList.length !== 1" class="btn-group">
                <button (click)="moveEntryUp(entry)" *ngIf="i !== 0" id="moveEntryUp{{i}}">
                    <mat-icon class="arrows" matTooltip="Move entry up" class="color-white-when-dark-mode">arrow_drop_up</mat-icon>
                </button>
                <button (click)="removeEntry(entry.entry_id)" id="deleteEntry{{i}}" matTooltip="Delete entry">
                    <mat-icon color="primary">delete</mat-icon>
                </button>
                <button (click)="moveEntryDown(entry)" *ngIf="i !== updatedScheduleList.length-1" id="moveEntryDown{{i}}">
                    <mat-icon class="arrows" matTooltip="Move entry down" class="color-white-when-dark-mode">arrow_drop_down</mat-icon>
                </button>
            </div>
            <div *ngIf="updatedScheduleList.length === 1" class="btn-group">
                <button (click)="removeEntry(entry.entry_id)" mat-icon-button matTooltip="Delete entry" id="removeEntry{{i}}">
                    <mat-icon color="primary">delete</mat-icon>
                </button>
            </div>
        </div>
        <div class="row-flex-2">
            <div class="entry-labels">
                <label class="mt10">Entry Times: </label>
            </div>
            <div class="entry-time">
                <app-date-interval-time-picker
                    initialDate="{{startDate[i]}}"
                    hint="Start Time and Date."
                    idSuffix="Start{{i}}"
                    timezone="{{defaultID}}"
                    [required]="true"
                    (dateChange)="startDate[i] = $event"
                    id="dateStartIntervalPicker{{i}}">
                </app-date-interval-time-picker>
            </div>
            <div class="entry-time">
                <app-date-interval-time-picker
                    initialDate="{{endDate[i]}}"
                    hint="End Time and Date."
                    idSuffix="End{{i}}"
                    timezone="{{defaultID}}"
                    [required]="false"
                    [endDate]="true"
                    (dateChange)="endDate[i] = $event"
                    id="dateEndIntervalPicker{{i}}">
                </app-date-interval-time-picker>
            </div>
            <div class="entry-type">
                <mat-form-field>
                    <mat-select [(ngModel)]="entry.frequency_name" (ngModelChange)="clearNextRotation()"
                                [(value)]="entry.frequency_name" id="entryFrequency_name{{i}}">
                        <mat-option *ngFor="let freq of scheduleTypes; let j = index" [value]="freq" id="freqType-{{i}}-{{j}}">{{freq}}</mat-option>
                    </mat-select>
                    <mat-hint>Repeat Frequency:</mat-hint>
                </mat-form-field>
            </div>
            <div *ngIf="entry.frequency_name.toLowerCase() === 'weekly'" class="day-select" id="changeDay{{i}}">
                <div (click)="changeDay(entry, day);  clearNextRotation()" *ngFor="let day of days; let j = index" id="changeDayEntry-{{i}}-{{j}}"
                     [class]="containsDay(entry, day.name) ? 'per-day-active' : 'per-day-inactive'"
                     matTooltip="{{day.name}}"> {{day.short}}
                </div>
            </div>
        </div>
        <div class="row-flex-2">
            <div class="entry-labels">
                <label class="mt10">Rotation Info: </label>
            </div>
            <div class="entry-time">
                <mat-form-field>
                    <input [readonly]="true" [value]="getRotationTimezone(entry.current) | date:'MM/dd/yyyy hh:mm a'"
                           id="currentRotation{{i}}" matInput type="text">
                    <mat-hint> Current rotation</mat-hint>
                </mat-form-field>
            </div>
            <div class="entry-time">
                <mat-form-field>
                    <input [readonly]="true" [value]="getRotationTimezone(entry.next) | date:'MM/dd/yyyy hh:mm a'"
                           matInput
                           id="nextRotation{{i}}" type="text">
                    <mat-hint>Next rotation</mat-hint>
                </mat-form-field>
            </div>
        </div>
        <div class="row-flex-2">
            <div class="entry-labels">
                <label>Participants: </label>
            </div>
            <div class="col-flex">
                <div class="participant-field">
                    <mat-chip-list (cdkDropListDropped)="drop($event, entry)" cdkDropList
                                   cdkDropListOrientation="vertical" id="participantsEntry{{i}}">
                        <mat-chip (removed)="removeParticipant(participant)"
                                  *ngFor="let participant of entry.participants; let j = index" cdkDrag class="w100" id="removeParticipantEntry-{{i}}-{{j}}">
                            <div class="participant-chip" id="UpdateParticipant-chip-{{i}}-{{j}}">
                                {{participant.participant_name}}
                                <div class="input-row" matTooltip="Enter duration in hours">
                                    Duration:
                                    <input [(ngModel)]="participant.duration"
                                           (ngModelChange)="participant.duration = makeEvenMultiple(participant.duration); clearNextRotation()"
                                           (keydown)="onChangeDuration($event)" class="participant-chip-duration text-current bg-transparent"
                                           id="duration-{{i}}-{{j}}" min=".25" step=".25" type="number"/>
                                    <mat-icon id="ChipRemove-{{i}}-{{j}}" matChipRemove>cancel</mat-icon>
                                </div>
                            </div>
                        </mat-chip>
                    </mat-chip-list>
                </div>
                <mat-form-field>
                    <input [(ngModel)]="individualInputs[i]" (focus)="clear(i)"
                           (input)="isGroup(entry) ? grpChange(individualInputs[i]) : indChange(individualInputs[i])"
                           [matAutocomplete]="autoIndividual" id="individualInput{{i}}" matInput/>
                    <mat-autocomplete #autoIndividual="matAutocomplete"
                                      (optionSelected)="setupParticipant($event.option.value, entry, i); clearNextRotation()"
                                      autoActiveFirstOption>
                        <mat-option *ngFor="let participant of autocompleteIndOrDevice; let j = index"
                                    [value]="participant" id="changeParticipant-{{i}}-{{j}}"> {{ participant.full_name ? participant.full_name : participant.name }} </mat-option>
                    </mat-autocomplete>
                    <mat-placeholder>
                        <mat-icon id="searchParticipant{{i}}">search</mat-icon>
                        New Participant
                    </mat-placeholder>
                    <mat-hint>Search for new {{isGroup(entry) ? 'group' : 'individual or channel'}} to add to entry
                    </mat-hint>
                </mat-form-field>
            </div>
        </div>
    </mat-card>
</mat-dialog-content>
<mat-dialog-content *ngIf="ready && !scheduleList" id="scheduleList">
    <h3> There are no schedules available.</h3>
</mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions">
    <button (click)="save()" [disabled]="!scheduleList" id="saveScheduleList" color="primary" mat-raised-button>Save</button>
    <button [mat-dialog-close]="closeDialog" id="cancelScheduleList" color="primary" mat-raised-button>Cancel</button>
</mat-dialog-actions>
